import mockData from './mockData'

const userServices = {
    fetchProfile: async token => {
        return new Promise(resolve => {
            setTimeout(() => {
                const profile = mockData.profile.find(info => info.token === token)

                resolve(profile)
            }, 2000)
        })
    },
}

export default userServices
